import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { ConfirmDialogButtonBase } from '../../shared/base/confirm-dialog-button-base';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { MESSAGE_CANNNOT_ENROLL_LECTURE_ERROR, MESSAGE_ENROLL_LECTURE_SUCCESS } from '../shared/lecture-message';
import { LectureUserService } from '../shared/lecture-user.service';

@Component({
  selector: 'app-lecture-enroll-button',
  template: '<ng-content></ng-content>'
})
export class LectureEnrollButtonComponent extends ConfirmDialogButtonBase {
  @Input() lecture: Lecture;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: LectureUserService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    const lecture = Object.assign(new Lecture(), this.lecture);
    if (lecture.isInProgress()) {
      this.openDialog();
    } else {
      this.openSnackBar(MESSAGE_CANNNOT_ENROLL_LECTURE_ERROR);
    }
  }

  openDialog(): void {
    super.openDialog('수강 신청', `${this.lecture.name} 강의에 수강 신청하시겠습니까?`, '신청', '취소');
  }

  async onSubmit() {
    try {
      await this.service.addUser(this.lecture);
      this.closeDialog();
      this.openSnackBar(MESSAGE_ENROLL_LECTURE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-enroll-button/lecture-enroll-button.component.ts